var render, staticRenderFns
import script from "./FormElement.vue?vue&type=script&lang=js&"
export * from "./FormElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ceedb2f')) {
      api.createRecord('3ceedb2f', component.options)
    } else {
      api.reload('3ceedb2f', component.options)
    }
    
  }
}
component.options.__file = "ScriptsV2/Core/Modules/PushNotifications/Components/Editor/FormElement.vue"
export default component.exports